<template>

    <div id="app">
        <el-container class="flextext">

            <home-head></home-head>
            <el-main>

                <div class="shop_main">
                    
                    
                    <div class="contain contain_qiangzhiquxiaoimportant bidding" style='height:auto;'>
                        
                        
                        
                        <h3 class="title">{{ bidding.title }}</h3>


                        <dl class="date">
                                                
                            <dt class="key">
                                <img class="avatar" :src="url + '/storage/' + bidding.avatar"  alt="" >
                            </dt>
                            <dd class="val">{{ bidding.user_name }}</dd>
                        
                            <template v-if="bidding.shop_id">
                                <dt class="key">店铺：</dt>
                                <dd class="val">
                                    <a :href="'#/shops/index/' + bidding.shop_id ">{{ bidding.shop_name }}</a>
                                </dd>
                            </template>
                            

                            <dt class="key">发布日期：</dt>
                            <dd class="val">{{ bidding.created_at.split(' ')[0] }}</dd>

                        </dl>

                        <p  class="description">{{ bidding.description }}</p>

                        <el-form>   
                        
                            <!-- <ul>
                                <li v-for="(item,index) in bidding_item" :key="index">
                                
                                    <span>{{ item.title }}</span>
                                    <span>{{ item.description }}</span>
                                    
                                    <el-input style="width:100px" v-model="item.price"></el-input>
                                </li>
                            </ul> -->

                            <el-table :data="bidding_item" class="bidding-item">
                            
                                <el-table-column prop="title" label="物料名称">
                                </el-table-column>
                                <el-table-column prop="description" label="要求">
                                </el-table-column>
                                <el-table-column prop="price" label="出价(￥)">
                                    <template slot-scope="scope" >
                                    
                                        <el-input type="number" v-model="scope.row.price"></el-input>
                                    </template>
                                </el-table-column>
                            </el-table>

                            <div class="reply">
                                <el-input v-model="reply" placeholder="请添加备注"></el-input>
                            </div>
                            
                            <div class="reply-btn">
                                <el-button  type="primary" @click="do_reply">回复</el-button>
                            </div>
                            
                        </el-form>
                        
                        

                    </div>
                    <div style="height:100px"></div>

                </div>
            </el-main>
            <footerall></footerall>
        </el-container>
    </div>
    
</template>
    
<script>

import home_head from '../../common/home-head_new';
import footerall from "../../common/footer";
export default {
    name: "wiki_detail",
    data: function () {
        return {

            
            url:'',
            bidding_id:0,
            bidding:{

            },

            reply:'', //回复的文本内容（备注）

        
        }
    },

    components: {
        'home-head': home_head,
        footerall
    },

    methods:{

        init:function(){

            this.url = window.config.api_url;
            this.bidding_id = this.$route.params.id;
            this.get_detail();
        },

        get_detail:function(){

            var t = this;
            var url = window.config.api_url + '/college/bidding/single/' + this.bidding_id;
            t.axios.get(url).then((res)=>{
                t.bidding = res.data;
                this.bidding_item = res.data.item;
            })

        },


        do_reply:function(){

            var t = this
            var url = window.config.api_url + '/user/bidding/reply';
            
            this.token = localStorage.getItem("uid");

            url += '?token=' + this.token;

            let formData = new FormData();

            
            for( var i = 0; i < this.bidding_item.length; i ++ ){

                formData.append('item[' + this.bidding_item[i].id + '][item_id]', this.bidding_item[i].id);
                var price = typeof this.bidding_item[i].price != 'undefined' ? this.bidding_item[i].price : 0;
                formData.append('item[' + this.bidding_item[i].id + '][price]', price);

            }
            

            formData.append('bidding_id', this.bidding_id);
            formData.append('reply', this.reply);

            
            t.axios.post( url, formData ).then((res)=>{

                this.$message({
                    message: res.data.status ? res.data.description : '回复成功',
                    type: res.data.status ? 'error' : 'success'
                });

            })

        },

    },

    created:function(){

        this.init();
    }

    
}
</script>
    
    <style lang="less" scoped>
        @import "../../../../node_modules/element-ui/lib/theme-chalk/display.css";
    
        @head_text: Source Han Sans CN;
        @font-face {
    
        }
    
        @import "../../../assets/css/home";
        @import "../../../assets/css/home_details";
        //@import "../../../assets/css/goods_detailed";
        .flextext {
            display: flex;
            flex-direction: column;
            flex: 1;
            flex-basis: auto;
            box-sizing: border-box;
            min-width: 0;
        }
    
        .btncss {
            position: absolute;
        }
    </style>
    
    <style lang="less" scoped>
    
    .shop_main{
        // max-width: 1200px;
        // width: 80%;
        margin:0 auto;
        
        .contain{
            margin-top:10px;
        }
    }
    .title{
        font-weight:bold;
        font-size:24px;
        margin: 10px 0;
        text-align:center;

    }

    .description{
        text-indent: 20px;
        margin-top: 20px;
    }

    .date{

        
        margin-top:10px;
        display: flex;
        align-items: center;
        justify-content: center;

        .avatar{
            width:30px;
            height:30px;
            border-radius:15px;
        }
        .key{
            display:inline-block;
            margin-right:10px;
        }

        .val{
            display:inline-block;
            margin-right:20px;
        }
    }

    .bidding-item{
        margin-top:20px;
    }
    .reply{

        margin-top:20px;
    }
   
    .reply-btn{
        text-align:right;
        margin-top:20px;
    }

</style>
    
